import { useParams } from 'next/navigation';
import { useMemo } from 'react';
import { InputFieldData, InputStateProps } from '../../@types/input-field-data';
import { getZipCodeLengthFromSlug } from './country-config';
import TextInput from './text-input';

export interface ZipCodeInputProps extends InputStateProps, InputFieldData {
  type: 'zip_code';
}

function ZipCodeInput(props: ZipCodeInputProps) {
  function handleInput(value: string) {
    props.onInput(value.toLocaleUpperCase().replace(/[^A-Z0-9\- ]|^\s+/g, ''));
  }

  const { slug } = useParams();

  const zipCodeLength = useMemo(() => {
    return getZipCodeLengthFromSlug(slug);
  }, [slug]);

  return (
    <TextInput
      {...props}
      inputClassName="md:w-[300px]"
      maxLength={zipCodeLength}
      name={props.name || 'zip_code'}
      onInput={handleInput}
      text={props.text || 'Zip Code'}
      type="text"
    />
  );
}

export default ZipCodeInput;
